<div class="flex flex-col gap-2">
  <div class="grid grid-cols-1 gap-4">
    <div class="flex flex-col gap-2">
      <label [for]="'functional-scope-' + position()">
        {{ 'multiselect.select.function' | transloco }}
        <span class="text-red">*</span>
        <app-directus-tooltip
          class="ml-2"
          tooltipKey="provider.tenderResponse.projectReferences.functionalScope"
        />
        <ng-content select="[labelBadge]" />
      </label>

      @if (isEditable()) {
        <p-multiSelect
          [inputId]="'functional-scope-' + position()"
          [options]="moduleGroups()"
          [group]="true"
          optionGroupLabel="id"
          optionGroupChildren="items"
          optionValue="id"
          [filter]="true"
          filterBy="filterText"
          [ngModel]="selectedFunctionIds()"
          [placeholder]="'common.select' | transloco"
          scrollHeight="500px"
          [panelStyle]="functionsPanelStyle()"
          [overlayOptions]="functionsOverlayOptions"
          appendTo="body"
          (onPanelShow)="onFunctionsPanelShow()"
          (ngModelChange)="onSelectionChange($event)"
        >
          <ng-template #group let-moduleGroup>
            <div class="flex items-center justify-between w-full">
              <span class="font-bold">{{ moduleGroup.translations | translateDirectus }}</span>
              <div
                class="flex items-center gap-2"
                role="presentation"
                (click)="$event.stopPropagation()"
              >
                <p-checkbox
                  [binary]="true"
                  [ngModel]="
                    moduleSelectionStates().get(moduleGroup.id) === ModuleSelectionState.ALL
                  "
                  [indeterminate]="
                    moduleSelectionStates().get(moduleGroup.id) === ModuleSelectionState.SOME
                  "
                  [styleClass]="
                    moduleSelectionStates().get(moduleGroup.id) === ModuleSelectionState.SOME
                      ? 'p-checkbox-checked'
                      : ''
                  "
                  (onChange)="onModuleToggle(moduleGroup, $event.checked)"
                />
                <span>{{ 'common.all' | transloco }}</span>
              </div>
            </div>
          </ng-template>

          <ng-template #item let-functionOption>
            <div class="flex items-center justify-between w-full gap-3">
              <app-module-function-label [translations]="functionOption.translations" />
              <div
                class="w-60"
                role="presentation"
                [class.invisible]="!statusByFunctionId().has(functionOption.id)"
                (click)="$event.stopPropagation()"
              >
                <app-model-field-select
                  [id]="'functional-scope-status-' + functionOption.id"
                  [options]="statusOptions()"
                  [showClear]="false"
                  [value]="statusByFunctionId().get(functionOption.id)"
                  (valueChange)="onStatusChange(functionOption.id, $event)"
                />
              </div>
            </div>
          </ng-template>

          <ng-template #selecteditems let-selectedOptions>
            @if (selectedOptions?.length > 0) {
              {{ selectedOptions.length }} {{ 'common.functions' | transloco }}
            }
          </ng-template>
        </p-multiSelect>
      } @else {
        <input
          pInputText
          [value]="selectedCount() + ' ' + ('multiselect.selected' | transloco)"
          [disabled]="true"
          class="w-full"
        />
      }
    </div>
  </div>

  <div class="flex flex-wrap gap-2">
    @for (chip of chips(); track chip.functionId) {
      <p-tag
        severity="secondary"
        class="px-4 py-2 text-base font-semibold shadow-xs border border-surface-700"
      >
        <span>{{ chip.functionTranslations | translateDirectus }}</span>
        @if (chip.statusTranslations.length > 0) {
          <span
            class="ml-2 px-2 py-0.5 text-xs font-medium rounded-sm bg-surface-950 text-surface-0"
          >
            {{ chip.statusTranslations | translateDirectus }}
          </span>
        }
        @if (isEditable()) {
          <button
            type="button"
            class="ml-2 flex items-center cursor-pointer text-red"
            [attr.aria-label]="'common.delete' | transloco"
            (click)="removeFunction(chip.functionId)"
          >
            <i class="pi pi-times-circle"></i>
          </button>
        }
      </p-tag>
    }
  </div>
</div>
